// extracted by mini-css-extract-plugin
export default {"zoomModal":"J3-z"};